// @flow

import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import ActionsDropdown from './ActionsDropdown';
import VerifyGuideContainer from './VerifyGuideContainer';
import { UsersContext } from './UsersContext';

import makeUrl from '../../../lib/makeUrl';

type State = {
  isVerifyingLeader: boolean,
};

type Props = {
  id: string,
  roles: null | Array<string>,
  email: null | string,
  fullname: string,
  index: number,
};

export default class UserInfo extends Component<Props, State> {
  state = { isVerifyingLeader: false };

  toggleEditor = () => {
    this.setState(prevState => {
      return { isVerifyingLeader: !prevState.isVerifyingLeader };
    });
  };

  render() {
    const { id, roles, email, fullname, index } = this.props;

    const { isVerifyingLeader } = this.state;

    const isLeader = roles && roles.includes('leader');

    return (
      <tr key={id}>
        <UsersContext.Consumer>
          {({ updateUser }) => {
            return (
              <Fragment>
                {isVerifyingLeader ? (
                  <td colSpan="5">
                    <VerifyGuideContainer id={id} />
                  </td>
                ) : (
                  <Fragment>
                    <th scope="row">{index}</th>
                    <td>
                      {email && email} / {fullname && fullname}
                    </td>
                    <td>
                      <Link to={makeUrl.goToProfile(fullname, id)} target="_blank">
                        {id}
                      </Link>
                    </td>
                    <td style={{ textTransform: 'capitalize' }}>
                      {Array.isArray(roles) && roles.join(', ').replace('_', ' ')}
                    </td>
                    <td>
                      <ActionsDropdown user={this.props} updateUser={updateUser} />
                    </td>
                  </Fragment>
                )}
                <td>
                  {isLeader ? (
                    <a onClick={this.toggleEditor}>
                      {isVerifyingLeader ? 'Close' : 'Verification Details'}
                    </a>
                  ) : null}
                </td>
              </Fragment>
            );
          }}
        </UsersContext.Consumer>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/UserInfo.jsx